module.exports = __webpack_public_path__ + "static/media/camera-off.23ff4c9b.svg";